module.exports = __webpack_public_path__ + "static/media/brsrMainBanner.af7be414.svg";